<template>
  <div  v-on:keyup.enter="clickedValidate" class="agent-portal-login form-group ut-w-3/5">
    <svg-loader name="logo-oa-default" type="logo" class="ut-flex-no-shrink ut-block ut-m-auto ut-pb-8" />
    <div class="form-group container">
      <h2 class="ut-text-center">Reset your account password</h2>
      <text-input
        class="subsection"
        :isMandatory="true"
        :label="form.password.label"
        :type="Types.Input.Password"
        @validated-fields="validate"
        @input="onInput"
      />
      <text-input
        class="subsection"
        :label="form.repeatPassword.label"
        :isMandatory="true"
        :type="Types.Input.Password"
        @validated-fields="validate"
        @input="onInput"
      />
      <span v-if="isError" id="error-message" class="error inline">
        {{ errorMsg }}
      </span>
      <oa-button
        class="subsection"
        :text="'Reset Password'"
        :btnClass="{ color: 'green' }"
        :disabled="disableSubmit"
        @click="clickedValidate"
        v-gaEvent="gaEvent('Agent Portal Login - Reset Password clicked')"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import OaButton from '@/components/Forms/OaButton.vue';
import TextInput from '@/components/Forms/TextInput.vue';
import FormHandler from '@/mixins/FormHandler';
import Types from '@/Mapper/CustomType';


export default {
  name: 'AgentPortalResetPassword',
  mixins: [
    FormHandler,
  ],
  components: {
    OaButton,
    TextInput,
    SvgLoader,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    passwordValue() {
      return this.form.password.values
        && this.form.password.values.value
        ? this.form.password.values.value
        : '';
    },
    repeatPasswordValue() {
      return this.form.repeatPassword.values
        && this.form.repeatPassword.values.value
        ? this.form.repeatPassword.values.value
        : '';
    },
    gaLabel() {
      return `AID=${this.agent.id}`;
    },
    isError() {
      return this.errorMsg !== '';
    },
  },
  data() {
    return {
      disableSubmit: false,
      errorMsg: '',
      Types,
      form: {
        password: {
          label: 'Your new password:',
          values: {},
        },
        repeatPassword: {
          label: 'Repeat password:',
          values: {},
        },
      },
    };
  },
  methods: {
    ...mapActions('userStore', {
      logInUser: 'logInUser',
      logOutUser: 'logOutUser',
    }),
    saveDetails() {
      this.disableSubmit = true;
      this.errorMsg = '';
      const data = {
        token: this.$route.params.rt,
        password: this.passwordValue,
        template: 'email-user-password-reset-confirmation',
      };

      if (data.password === this.repeatPasswordValue) {
        console.log(data);
        console.log('reset password');
        this.$apiServices.oa.security.resetPassword(data)
          .then((userData) => {
            this.resetInputs();
            this.disableSubmit = false;
            this.backToLogin();
            this.$helpers.gaEvent(
              'AgentPortal',
              'Agent Portal - Password Reset',
              `AID=${userData.agentid}`,
            );
            this.$emit('forgot-password');
          })
          .catch((error) => {
            this.errorMsg = error;
            console.error(error);
            this.disableSubmit = false;
          });
      } else {
        this.disableSubmit = false;
        this.errorMsg = 'Passwords do not match';
      }
    },
    gaEvent(eventAction, eventLabel) {
      const label = `AID=${this.agent.id}${eventLabel ? ` | ${eventLabel}` : ''}`;
      return {
        category: 'AgentPortal',
        action: eventAction,
        label,
      };
    },
    backToLogin() {
      this.$emit('back-to-login');
    },
  },
};

</script>

<style lang="scss" scoped>

.agent-portal-login .container {
  @apply ut-mb-3 ut-overflow-hidden ut-relative ut-p-6;
  box-shadow: 0 1px 2px 0 rgba(36,33,25,0.09), 0 2px 4px 0 rgba(36,33,25,0.17);
  border-radius: 5px;
  background-color: #FFFFFF;
  font-size: 14px;
  line-height: 18px;
}

.btn {
  margin-bottom: 15px;
}

.hint {
  @apply ut-text-sm ut-font-light;
}

.ut-flex .subsection {
  @apply ut-mx-2;
}

.subsection {
  @apply ut-p-2;
}

a {
  @apply ut-block ut-underline ut-text-green-400;
}

h2 {
  @apply ut-text-xl ut-font-bold ut-pb-6;
}

</style>
